module.exports = __webpack_public_path__ + "img/2.7047adba.jpg";